import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "src/providers/auth.service";
import { RxwebValidators } from "@rxweb/reactive-form-validators";
import { UtilsProvider } from "src/commons/utils";
@Component({
	selector: "app-register",
	templateUrl: "./register.component.html",
	styleUrls: ["./register.component.scss", "../app.component.scss"]
})
export class RegisterComponent implements OnInit {

	public registerForm: any;
	public registerFormStep: any;

	constructor(
		public router: Router,
		public formBuilder: FormBuilder,
		public auth: AuthService,
		public utils: UtilsProvider
	) { }

	ngOnInit() {
		const email = new FormControl("", Validators.compose([Validators.required, Validators.email]));
		const name = new FormControl("", Validators.compose([Validators.required]));
		const telefone = new FormControl("", Validators.compose([Validators.required]));
		const password = new FormControl("", Validators.compose([Validators.required]));
		const confirmPassword = new FormControl("", Validators.compose([
			Validators.required,
			RxwebValidators.compare({fieldName: "password" }),
		]));
		this.registerFormStep = 0;
		this.registerForm = [
			{
				fields: [
					{
						name: "name",
						type: "text",
						placeholder: "Nome Completo",
						blurCallback() { }
					},
					{
						name: "email",
						type: "email",
						placeholder: "E-mail",
						blurCallback() { }
					},
					{
						name: "telefone",
						type: "mask",
						mask: {mask: "(00) 00000-0000", len:  15},
						placeholder: "Telefone",
						blurCallback() { }
					},
					{
						name: "password",
						type: "password",
						placeholder: "Senha",
						blurCallback() { }
					},
					{
						name: "confirmPassword",
						type: "password",
						placeholder: "Confirme sua senha",
						blurCallback() { }
					},
				],
				builder: this.formBuilder.group({
					name,
					email,
					telefone,
					password,
					confirmPassword
				}),
				validation_messages: {
					name: [
						{ type: "required", message: "Preencha o campo nome." },
					],
					telefone: [
						{ type: "required", message: "Preencha o campo telefone." },
					],
					email: [
						{ type: "required", message: "Preencha o campo e-mail." },
					],
					password: [
						{ type: "required", message: "Preencha o campo senha." },
					],
					confirmPassword: [
						{ type: "required", message: "Preencha o campo confirme sua senha." },
						{ type: "compare", message: "Os campos devem ter o mesmo valor." },
					],
				},
			},
		];
	}

	clean() {
		this.registerForm[0].builder.reset();
	}

	onSubmit(event) {
		if (!this.registerForm[0].builder.valid) {
			return this.utils.toast({
				message: "Por favor, preencha corretamente o formulário.",
				action: "Ok",
				duration: 10000
			});

		}
		const data = { ...event[0].builder.value };
		this.auth.register(data).then((res) => {
			this.clean();
			this.utils.toast({
				message: "Seja bem vindo ao YouDoctor! Por favor, Selecione uma instituição.",
				duration: 10000
			});
			this.router.navigate(["/pages/home"]);
		}).catch(err => {
			return this.utils.toast({
				message: "Ocorreu um erro ao realizar seu cadastro, tente novamente mais tarde.",
				action: "Ok",
				duration: 10000
			});
		});
	}
}
